import { Injectable } from '@angular/core';

let moment = require('moment');

@Injectable()
export class FileTableService {

    statusmap = {
        'pending': 'verstuurd',
        'locked': 'compleet',
        'ready': 'download',
        'notsent': 'versturen',
        'late': 'late'
    }

    forContractor = false;

    roommap = {
        'alle ruimtes': 'woning',
        'volledige woning': 'woning',
        'zwembad/zwemvijver': 'zwembad',
        'kantoorruimte beneden': 'kantoor',
        'douchekamer': 'badkamer',
        'badkamer': 'badkamer',
        'dak': 'dak',
        'eetkamer': 'eetkamer',
        'eetplaats': 'eetplaats',
        'garage': 'garage',
        'kantoor': 'kantoor',
        'kantoren': 'kantoren',
        'kelder': 'kelder',
        'keuken': 'keuken',
        'salon': 'salon',
        'tuin': 'tuin',
        'voortuin': 'voortuin',
        'woonkamer': 'woonkamer',
        'zwembad': 'zwembad',
        'Hall': 'andere'
    }


    status2imgfn(status) {
        let stat = this.statusmap[status];
        return `../../assets/Nestas-Iconen_${stat}.png`;
    }

    getStatus(row, pid = null, uploaded = null) {
        if (row.providedByContractor && !row.contractor) return 'notsent';

        var now = moment().startOf('day');

        //console.log("get status", row.name, "sharing type", row.sharingType, "pid", pid, "version", row.version, this.forContractor);
        if (row.sharingType == 'distinct') {
            //console.log("row", row);
            if (row.version) {
                //console.log("version", row.version, row, this.forContractor);
                if (this.forContractor) {
                    /*if (uploaded) {
                        console.log("row", row, "uploaded", uploaded);
                    }*/
                    if (!pid || pid._id) {
                        var rowVersion = row.version && (row.version.filter && row.version.filter(x => x.PID && x.PID._id || x.PID) || [row.version]) || [];
                        //console.log("row version 1a", pid, row.version);
                        if (rowVersion.length) return (row.locked ? 'locked' : 'ready');
                    } else {
                        var rowVersion = row.version && (row.version.filter && row.version.filter(x => x.PID && x.PID._id || x.PID) || [row.version]) || [];
                        rowVersion = row.version.map(x => x.PID && x.PID._id || x.PID).filter(x => x == pid);
                        //console.log("row version 1b", pid, rowVersion);

                        if (rowVersion.length) return (row.locked ? 'locked' : 'ready');

                    }

                } else {
                    //console.log("0:", row.sharing, pid._id || pid, row.sharing.indexOf(pid._id || pid), row.version.missing);
                    if (row.sharing && row.sharing.indexOf(pid._id || pid) > -1) {
                        //console.log("1", pid, row.PID._id || row.PID);

                        if (typeof (row.version.missing) !== 'undefined') {
                            if (row.version.missing.indexOf(pid._id || pid) == -1) {
                                //console.log("a");
                                return (row.locked ? 'locked' : 'ready');
                            }
                        } else {
                            //console.log("1b row version", row.version, row.version.PID, pid, pid == row.version.PID);
                            if (row.version && pid == row.version.PID) {
                                //console.log("1b ready");

                                return (row.locked ? 'locked' : 'ready');
                            }

                        }
                    } else {
                        //console.log("2: sharing", row.sharing, "row.PID", row.PID._id || row.PID, "sharing", row.sharing && row.sharing.indexOf(row.PID._id || row.PID), "missing", row.version.missing);
                        if (typeof (row.version.missing) !== 'undefined') {
                            if (row.version && row.version.missing && row.version.missing.length == 0) {
                                console.log("2a");
                                return (row.locked ? 'locked' : 'ready');
                            }
                        } else {
                            //console.log("2b: sharing", row.fullVersion);

                            if (row.fullVersion) {
                                var uploaded = row.fullVersion.filter(x => x.PID).map(x => x.PID.toString());
                                var missing = row.sharing.filter((elem, pos) => uploaded.indexOf(elem) === -1);

                                if (missing.length == 0) {
                                    return (row.locked ? 'locked' : 'ready');
                                }
                            }
                        }
                    }
                }
            }
            if (row.deadline && now.isAfter(row.deadline)) {
                return 'late';
            }
            return 'pending';
        }

        if (!row.version || !(row.version.files || row.version[0]) || (row.sharingType == 'distinct' && !row.version.complete)) {
            if (row.deadline && now.isAfter(row.deadline)) {
                return 'late';
            }

            return 'pending';
        }

        if (!this.forContractor && row.locked) return 'locked';

        return 'ready';
    }


    room2imgfn(room) {
        let lcroom = room.toLowerCase() in this.roommap ? this.roommap[room.toLowerCase()] : 'andere';
        return `../../assets/Nestas-Iconen_${lcroom}.png`;
    }

    contractorClass(row) {
        if (row.contractor && row.contractor.name && row.contractor.name.indexOf(',') > -1) return "";
        return "center";
    }

    formatContractor(row) {
        if (!row.contractor) return "";
        if (row.contractor.name && row.contractor.name.indexOf(',') > -1) {
            return row.contractor.name.split(',').slice(0, 2).join(',');
        } else {
            return row.contractor.name;
        }
    }

    constructor() { }

}